import Select from 'react-select';

type Option = { value: string; label: string };

type Props = {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isClearable?: boolean;
  className?: string;
};

export default function SimpleSelect({
  options,
  value,
  onChange,
  placeholder,
  isClearable = false,
  className = '',
}: Props) {
  const selectedOption = options.find((opt) => opt.value === value) || null;

  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={(opt) => onChange(opt?.value ?? '')}
      isClearable={isClearable}
      placeholder={placeholder}
      className={className}
      classNamePrefix="select"
      isSearchable={false}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 50 }) }}
    />
  );
}
